import request from "@/utils/request.js";
//收银台详情
export function h5CashRegisterGetUpi(data,headers) {
  return request({
    url: "/h5Api/v1/h5CashRegisterGetUpi",
    method: "post",
    data,
    headers
  });
}

//一类收银台详情
export function h5CashRegisterGetUpiV2(data,headers) {
  return request({
    url: "/h5Api/v2/h5CashRegisterGetUpi",
    method: "post",
    data,
    headers
  });
}

//一类收银台点击
export function h5CheckOutClickV2(data,headers) {
  return request({
    url: "/h5Api/v2/h5CheckOutClick",
    method: "post",
    data,
    headers
  });
}

//一类收银台提交UTR
export function h5CheckOutUtrSubmitV2(data,headers) {
  return request({
    url: "/h5Api/v2/h5CheckOutUtrSubmit",
    method: "post",
    data,
    headers
  });
}

// 埋点
export function h5OrderBuriedPointCreate(data,headers) {
  return request({
    url: "/h5Api/v1/h5OrderBuriedPointCreate",
    method: "post",
    data,
    headers
  });
}

//收银台复制
export function h5CopyUpi(data,headers) {
  return request({
    url: "/h5Api/v1/h5CopyUpi",
    method: "post",
    data,
    headers
  });
}
//收银台提交
export function h5PayingSubmit(data,headers) {
  return request({
    url: "/h5Api/v1/h5PayingSubmit",
    method: "post",
    data,
    headers
  });
}
//收银台查询订单
export function h5PayOrderQuery(data,headers) {
  return request({
    url: "/h5Api/v1/h5PayOrderQuery",
    method: "post",
    data,
    headers
  });
}
//获取图形验证码
export function captcha(data,headers) {
  return request({
    url: "/app/api/system/captcha",
    method: "post",
    data,
    headers
  });
}

//注册
export function register(data,headers) {
  return request({
    url: "/app/api/system/register",
    method: "post",
    data,
    headers
  });
}

// utr提交最新接口（一类二类公用）
export function h5CheckOutUtrSubmit(data,headers) {
  return request({
    url: "/h5Api/v1/h5CheckOutUtrSubmit",
    method: "post",
    data,
    headers
  });
}

// 获取滑块验证码
export function getImageVerificationCode(data,headers) {
  return request({
    url: "/app/api/system/getImageVerificationCode",
    method: "post",
    data,
    headers
  });
}

// 获取短信验证码
export function sendSms(data,headers) {
  return request({
    url: "/app/api/system/v2/sendSms",
    method: "post",
    data,
    headers
  });
}

// 获取验证码场景ID
export function getSceneId(data,headers) {
  return request({
    url: "/app/api/system/getSceneId",
    method: "post",
    data,
    headers
  });
}

